const mediaItems = [
  {
    id: 1,
    title: '本周娱乐圈大瓜盘点',
    source: '娱乐圈速报',
    views: '128万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20entertainment%20news%20collage%20with%20microphone%20spotlight%20and%20red%20carpet%20elements%2C%20warm%20coral%20and%20amber%20tones%2C%20editorial%20magazine%20cover%20style%2C%20modern%20clean%20design%2C%20soft%20gradients%2C%20no%20text%20no%20letters%2C%20abstract%20showbiz%20theme&width=800&height=500&seq=media-01-2026&orientation=landscape',
  },
  {
    id: 2,
    title: '网红翻车名场面合集',
    source: '吃瓜一线',
    views: '96万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20social%20media%20live%20streaming%20scene%20with%20smartphone%20screen%20and%20reaction%20emojis%2C%20warm%20coral%20and%20amber%20color%20palette%2C%20modern%20flat%20design%20style%2C%20clean%20composition%2C%20entertainment%20theme%2C%20no%20text%20no%20letters%2C%20playful%20vibe&width=800&height=500&seq=media-02-2026&orientation=landscape',
  },
  {
    id: 3,
    title: '综艺节目神操作盘点',
    source: '综艺挖宝',
    views: '85万',
    img: 'https://readdy.ai/api/search-image?query=Stylized%20illustration%20of%20TV%20variety%20show%20stage%20with%20colorful%20lights%20and%20audience%20silhouettes%2C%20warm%20coral%20amber%20palette%2C%20modern%20graphic%20design%20style%2C%20entertainment%20atmosphere%2C%20no%20text%20no%20letters%2C%20abstract%20showbiz%20energy&width=800&height=500&seq=media-03-2026&orientation=landscape',
  },
  {
    id: 4,
    title: '电竞圈劲爆内幕揭秘',
    source: '电竞吃瓜社',
    views: '72万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20esports%20arena%20atmosphere%20with%20gaming%20peripherals%20and%20trophy%20silhouettes%2C%20warm%20coral%20and%20amber%20tones%2C%20modern%20minimalist%20design%2C%20competitive%20gaming%20theme%2C%20no%20text%20no%20letters%2C%20dynamic%20energy&width=800&height=500&seq=media-04-2026&orientation=landscape',
  },
  {
    id: 5,
    title: '短视频平台热门事件',
    source: '抖音频道',
    views: '63万',
    img: 'https://readdy.ai/api/search-image?query=Abstract%20illustration%20of%20short%20video%20app%20interface%20with%20floating%20heart%20and%20share%20icons%2C%20warm%20coral%20amber%20color%20palette%2C%20modern%20clean%20design%2C%20social%20media%20theme%2C%20no%20text%20no%20letters%2C%20trending%20vibe&width=800&height=500&seq=media-05-2026&orientation=landscape',
  },
];

export default function MediaSection() {
  return (
    <section id="media" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading text-foreground-900 mb-3">
            🎬 吃瓜视频
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            热门视频速览，视觉化呈现今日吃瓜热门大瓜事件
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-4">
          {mediaItems.map((item) => (
            <a
              key={item.id}
              href="#media"
              className="group block rounded-xl overflow-hidden bg-background-50 border border-background-200/70 hover:border-primary-200 transition-all duration-200 cursor-pointer"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.img}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                />
                <div className="absolute inset-0 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-primary-500/90 flex items-center justify-center group-hover:bg-primary-600 transition-colors">
                    <i className="ri-play-fill text-background-50 text-xl ml-0.5"></i>
                  </div>
                </div>
                <div className="absolute bottom-2 right-2 px-2 py-0.5 rounded bg-black/60 text-background-50 text-[10px] font-label whitespace-nowrap">
                  {item.views} 次播放
                </div>
              </div>
              <div className="p-3">
                <h3 className="text-sm font-medium text-foreground-700 group-hover:text-primary-600 transition-colors line-clamp-2 leading-snug">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-400 mt-1 whitespace-nowrap">{item.source}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}